import React from "react";
import "./RectangleLoader.css";

const RectangleLoader = props => (
  <div {...props} className="rectangle_loader">
    <div className="full" />
    <div className="full" />
    <div className="half" />
  </div>
);

export default RectangleLoader;
